// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3SnL8","colMaxWidth":"Table_colMaxWidth__2H8e8"};